var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "el-container",
        [
          _c(
            "el-aside",
            {
              staticClass: "el-aside",
              style: { width: _vm.fold ? 64 + "px" : 200 + "px" }
            },
            [_c("nav-left", { attrs: { fold: _vm.fold } })],
            1
          ),
          _vm._v(" "),
          _c(
            "el-container",
            [
              _c(
                "el-header",
                [_c("headers", { on: { handleFold: _vm.handleFold } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-main",
                {
                  staticStyle: {
                    overflow: "auto",
                    background: "rgb(240,242,245)"
                  }
                },
                [_c("router-view")],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24b4a97a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24b4a97a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout.vue
// module id = null
// module chunks = 